<div class="card-container" #container>
    <div class="card-header-wrapper">
        <h3 class="card-title"> {{ customMsgService.translate('armarios') }} </h3>
        <span></span>
    </div>

    <div class="card-component">
        <kendo-grid [kendoGridBinding]="gridView" kendoGridSelectBy="id" [selectedKeys]="mySelection" [pageSize]="10"
            [pageable]="true" [sortable]="true" [groupable]="true" [reorderable]="true" [resizable]="true"
            [height]="690" [columnMenu]="{ filter: true }" (filterChange)="filterChange($event)">
            <ng-template kendoGridToolbarTemplate>
                <kendo-textbox [placeholder]="customMsgService.translate('gridSearch')" kendoTextBox
                    style="width: 230px;" (valueChange)="onFilter($event)">
                </kendo-textbox>
                <kendo-grid-spacer></kendo-grid-spacer>

                <!-- criar armario -->
                <button [hidden]="!canCreate()" kendoButton (click)="open()"
                    [title]="customMsgService.translate('btnCriar')" icon="add" themeColor="primary">
                </button>

                <!-- Excel Botao -->
                <button kendoGridExcelCommand type="button" [title]="customMsgService.translate('btnExportarExcel')"
                    icon="file-excel" themeColor="warning">
                </button>

                <!-- PDF Botao -->
                <button kendoGridPDFCommand icon="file-pdf" [title]="customMsgService.translate('btnExportarPDF')"
                    themeColor="warning"> </button>
            </ng-template>

            <!-- nome do armario -->ß
            <kendo-grid-column field="nome" [title]="customMsgService.translate('name')" [width]="160">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="customer-name"> {{ dataItem.nome }} </div>
                </ng-template>
            </kendo-grid-column>

            <!-- numero de serie -->
            <kendo-grid-column field="numeroDeSerie" [title]="customMsgService.translate('numeroDeSerie')"
                [width]="120">
            </kendo-grid-column>

            <!-- numero de casifos -->
            <kendo-grid-column field="numeroUtilDeCacifos" [title]="customMsgService.translate('cacifos')" [width]="100"
                [class]="{ 'text-center': true }" [resizable]="false">
            </kendo-grid-column>

            <!-- localização do armario -->
            <kendo-grid-column field="nomeLocal" [title]="customMsgService.translate('location')" [width]="120">
            </kendo-grid-column>

            <!-- configuração do armario -->
            <kendo-grid-column title="" [width]="45">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button kendoGridEditCommand icon="wrench" [hidden]="!canAssociacaoEdit()"
                        [title]="customMsgService.translate('configuracaoDoArmario')"
                        (click)="openEditEstadoArmario(dataItem)" [primary]="true"></button>
                </ng-template>
            </kendo-grid-column>

            <!-- vista armario -->
            <kendo-grid-column title="" [width]="45">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button kendoGridEditCommand icon="preview" [hidden]="!canAssociacaoList()"
                        [title]="customMsgService.translate('estadoDoArmario')" (click)="openEstadoArmario(dataItem)"
                        [primary]="true"></button>
                </ng-template>
            </kendo-grid-column>

            <!-- editar armario -->
            <kendo-grid-column title="" [width]="45">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button kendoGridEditCommand icon="pencil" [hidden]="!canEdit()"
                        [title]="customMsgService.translate('btnEditar')" (click)="openEdit(dataItem)"
                        [primary]="true"></button>
                </ng-template>
            </kendo-grid-column>

            <!-- eliminar armario -->
            <kendo-grid-column title="" [hidden]="!canEdit()" [width]="45">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button kendoGridEditCommand icon="delete" [title]="customMsgService.translate('btnEliminar')"
                        (click)="delete(dataItem)" themeColor="error"></button>
                </ng-template>
            </kendo-grid-column>

            <!-- PDF  -->
            <kendo-grid-pdf fileName="{{customMsgService.translate('armarios')}}.pdf" [repeatHeaders]="true"
                [allPages]="true" paperSize="A4" [landscape]="true" [scale]="0.6">
                <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
                <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
                    <div class="page-template">
                        <div class="header">
                            <div style="float: left">
                                {{ customMsgService.translate('armarios') }}
                            </div>
                        </div>
                        <div class="footer">{{ customMsgService.translate('pagina') }} {{ pageNum }} {{
                            customMsgService.translate('de_') }} {{ totalPages }}</div>
                    </div>
                </ng-template>
                <kendo-grid-column field="nome" [title]="customMsgService.translate('name')">
                </kendo-grid-column>
                <kendo-grid-column field="numeroDeSerie" [title]="customMsgService.translate('numeroDeSerie')">
                </kendo-grid-column>
                <kendo-grid-column field="numeroUtilDeCacifos" [title]="customMsgService.translate('cacifos')"
                    [class]="{ 'text-center': true }" [resizable]="false">
                </kendo-grid-column>
                <kendo-grid-column field="nomeLocal" [title]="customMsgService.translate('location')">
                </kendo-grid-column>
            </kendo-grid-pdf>

            <!-- Excel -->
            <kendo-grid-excel [fetchData]="allData" fileName="{{customMsgService.translate('armarios')}}.xlsx">
            </kendo-grid-excel>

        </kendo-grid>
    </div>
</div>
<div kendoDialogContainer></div>